import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonRow,
  IonTitle,
  IonToggle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { IDecaListPeriod } from '../deca-store.model';
import { DecaStoreService } from '../deca-store.service';

@Component({
  selector: 'lib-deca-search-modal',
  templateUrl: './deca-search-modal.component.html',
  styleUrls: ['./deca-search-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ReactiveFormsModule,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonIcon,
    IonContent,
    IonFooter,
    IonItem,
    IonInput,
    IonToggle,
    IonGrid,
    IonRow,
    IonCol,
    TranslateModule,
  ],
})
export class DecaSearchModalComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly modalCtrl = inject(ModalController);
  private readonly decaStoreService = inject(DecaStoreService);

  // comes from the component that opens the modal
  public readonly period!: IDecaListPeriod;

  protected readonly withoutPlate = signal(false);

  public searchForm: FormGroup;

  constructor() {
    this.searchForm = this.fb.group({
      plate: [''],
    });
  }

  ngOnInit(): void {
    // componentProps are assigned after construction, so the filters are reflected here.
    const current = this.decaStoreService.activeFiltersFor(this.period);
    this.withoutPlate.set(current?.withoutPlate ?? false);
    this.searchForm.patchValue({ plate: current?.plate ?? '' });
  }

  public onWithoutPlateChange(checked: boolean): void {
    this.withoutPlate.set(checked);
    this.searchForm.get('plate')?.setValue('');
  }

  public confirm(): Promise<boolean> {
    if (this.withoutPlate()) {
      this.decaStoreService.applyFilters({ withoutPlate: true }, this.period);
    } else {
      const plate = this.searchForm.get('plate')?.value?.trim();

      if (plate) {
        this.decaStoreService.applyFilters({ plate }, this.period);
      } else {
        this.decaStoreService.clearFilters(this.period);
      }
    }

    return this.modalCtrl.dismiss(null, 'confirm');
  }

  public cancel(): Promise<boolean> {
    return this.modalCtrl.dismiss(null, 'cancel');
  }
}
